/**
 * Internal dependencies
 */
import { PREFIX_EVENTS_STORE } from '@moderntribe/events/data/utils';

export const ADD_BLOCK = `${ PREFIX_EVENTS_STORE }/ADD_BLOCK`;
export const SET_TERM = `${ PREFIX_EVENTS_STORE }/SET_TERM`;

export const SET_SEARCH_POST_TYPE = `${ PREFIX_EVENTS_STORE }/SET_SEARCH_POST_TYPE`;

export const SEARCH = `${ PREFIX_EVENTS_STORE }/SEARCH`;
export const SET_SEARCH_IS_LOADING = `${ PREFIX_EVENTS_STORE }/SET_SEARCH_IS_LOADING`;

export const SET_RESULTS = `${ PREFIX_EVENTS_STORE }/SET_RESULTS`;
export const ADD_RESULTS = `${ PREFIX_EVENTS_STORE }/ADD_RESULTS`;

export const SET_PAGE = `${ PREFIX_EVENTS_STORE }/SET_PAGE`;
export const SET_TOTAL_PAGES = `${ PREFIX_EVENTS_STORE }/SET_TOTAL_PAGES`;

export const CLEAR_BLOCK = `${ PREFIX_EVENTS_STORE }/CLEAR_BLOCK`;
